enum SemiologyCategory {
    SPECIFIC = 'SPECIFIC',
    BASIC = 'BASIC'
}

export default SemiologyCategory;
